import styled from "styled-components";
import { colors } from "../../../theme/theme";


export const MediaTemplate = styled.div`
    float: right;
    .popover-title{
        color: ${colors.greyscale.darker_grey}
    }
`;

export const CategoryIcon = styled.em`
    color: ${colors.greyscale.grey};
    font-size: 21px;
    cursor: pointer;
`;